export default function GrooveGlowIntro() {
  return (
    <section className="py-32 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            What Is Groove &amp; Glow
          </h2>
          <p className="text-cyan-400 text-2xl font-light tracking-wide">
            A story-driven performance platform where dance, technology and culture converge.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
            <p className="text-xl">
              <strong className="text-white">Groove &amp; Glow is not an event.</strong><br />
              It is a long-term performance and experience platform built at the intersection of dance, technology, storytelling and wellness.
            </p>
            <p>
              At its core, Groove &amp; Glow transforms movement into narrative, and performance into immersive experience — blending live dance, virtual worlds, AI, and digital communities into a single evolving ecosystem.
            </p>
            <p>
              Built on the mythology of <strong className="text-cyan-400">The Broken Seal</strong> and the <strong className="text-orange-400">Five Elements</strong>, Groove &amp; Glow creates a new category of hybrid performance — where artists, teams, brands and organisations participate not just in competitions, but in story universes and experiential journeys.
            </p>
          </div>
        </div>

        {/* Three Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-gradient-to-br from-orange-500/10 to-orange-600/5 rounded-2xl p-8 border border-orange-500/20 hover:border-orange-500/50 transition-all hover:shadow-xl hover:shadow-orange-500/10">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center mb-6">
              <i className="ri-trophy-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Performance Platform</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-orange-400 mt-1"></i>
                <span>Live competitions</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-orange-400 mt-1"></i>
                <span>Virtual stages</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-orange-400 mt-1"></i>
                <span>Cinematic choreography</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-cyan-500/10 to-cyan-600/5 rounded-2xl p-8 border border-cyan-500/20 hover:border-cyan-500/50 transition-all hover:shadow-xl hover:shadow-cyan-500/10">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center mb-6">
              <i className="ri-book-open-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Story Universe</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-cyan-400 mt-1"></i>
                <span>Five Elements narrative</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-cyan-400 mt-1"></i>
                <span>Broken Seal mythology</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-cyan-400 mt-1"></i>
                <span>Character-driven journeys</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-green-500/10 to-green-600/5 rounded-2xl p-8 border border-green-500/20 hover:border-green-500/50 transition-all hover:shadow-xl hover:shadow-green-500/10">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center mb-6">
              <i className="ri-settings-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Experience Engine</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span>Corporate workshops</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span>Technology showcases</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span>Brand integrations</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mb-12">
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Groove &amp; Glow is designed as a <strong className="text-white">cultural IP and experiential platform</strong> — scalable across competitions, corporate programs, festivals, digital worlds and global markets.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Explore Workshop Options
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
